// Shared dataTransfer MIME used for entity drag-and-drop.
// The drag source (e.g. a target-list row) sets the entity id; any drop
// target that handles this mime focuses the entity on its own context
// (panel header → set this panel's entity, watchlist bar → add to
// watchlist, etc.).
export const ENTITY_MIME = 'application/x-hequity-entity-id';
